import { IReduxStore } from "Redux/Store/IReduxStore";

export const getSpot = (state: IReduxStore, id: number|string) => state.spot.spot.entries[id];
